export default __webpack_public_path__ + "static/benefit-img-5e2a0339e0c11d01521af90c104b752f.png";